import PageToolbar from '@/components/linear/page-toolbar';
import { projectPath } from '@/lib/linear-paths';
import ProjectForm from '@/pages/projects/components/project-form';
import type { Company } from '@/types/company';
import type { Project } from '@/types/project';

interface Props {
  project: Project;
  companies: Company[];
}

export default function Edit({ project, companies }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar title={`Edit ${project.name}`} showNew={false} />
      <div className="ln-page-scroll">
        <div className="ln-form-page">
          <h1>Edit {project.name}</h1>
          <p className="ln-lede">Update name, end state, or company.</p>
          <ProjectForm
            project={project}
            companies={companies}
            action={projectPath(project.id)}
            method="patch"
            submitLabel="Save changes"
          />
        </div>
      </div>
    </div>
  );
}
